import { Component, inject } from '@angular/core';
import { AuthzService } from '../../core/auth/authz.service';
// PrimeNG
import { ButtonModule } from 'primeng/button';
import { LanguageConfigComponent } from '../../pattern/language-config/language-config.component';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-login-with-social',
  imports: [ButtonModule, LanguageConfigComponent, TranslocoModule],
  template: `
    <div class="flex flex-column h-screen bg-landing">
      <div class="flex justify-content-end w-full px-3 pt-3 sm:pb-3">
        <app-language-config></app-language-config>
      </div>
      <div class="flex h-full w-full justify-content-center align-items-center ">
        <div
          class="flex flex-column gap-8 justify-content-center align-items-center border-round-2xl bg-white p-5"
          style="width: 494px; height: 566px;"
        >
          <div class="flex flex-column justify-content-center align-items-center gap-5">
            <div class="flex flex-column justify-content-cente align-items-center gap-3">
              <img class="w-9rem h-9rem object-contain" src="assets/images/img-connect-not-found.png" alt="not-found" />
              <p class="text-2xl text-gray font-semibold">{{ 'login_with_social.header' | transloco }}</p>
            </div>
            <p class="text-base text-bluegray-500 font-normnal break-word">
              {{ 'login_with_social.sub_header' | transloco }}
            </p>
          </div>
          <div class="w-full">
            <p-button
              [label]="'login_with_social.button' | transloco"
              styleClass="w-full"
              (click)="handleLogout()"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class LoginWithSocialComponent {
  authzService = inject(AuthzService);

  handleLogout() {
    this.authzService.logout();
  }
}
